// extracted by mini-css-extract-plugin
export default {"main":"Main_main__Uxwo5","filters":"Main_filters__08Cvu","inputFilter":"Main_inputFilter__-o2JS","inputMagnifier":"Main_inputMagnifier__toFtw","content":"Main_content__JlVXI"};